import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer";
import { postForgotPassword } from "../../../helpers/fakebackend_helper";

export const userForgetPassword = (user) => async (dispatch) => {
  try {
    const data = await postForgotPassword({ email: user.email });
    if (data) {
      dispatch(userForgetPasswordSuccess("Таны имэйл хаяг руу нууц үг сэргээх холбоос илгээлээ"));
    }
    return { success: true };
  } catch (err) {
    // Rate limit error — { message, waitSeconds }
    if (err && typeof err === "object" && err.waitSeconds) {
      dispatch(userForgetPasswordError(err.message));
      return { waitSeconds: err.waitSeconds };
    }
    dispatch(userForgetPasswordError(typeof err === "string" ? err : "Алдаа гарлаа. Дахин оролдоно уу"));
    return { error: true };
  }
};
